export default [
    {
        path: '/customer/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ './views/Login')
    },
    {
        path: '/customer/create',
        name: 'create',
        component: () => import(/* webpackChunkName: "create" */ './views/Create')
    },
    {
        path: '/customer/logout',
        name: 'logout'
    }
]
